import axios from "utils/axios";
class PollService {
  getAllPoll(teamId, page) {
    return axios.get(`/user/team/${teamId}/poll`, {
      params: {
        page,
      },
    });
  }
  createPoll(data) {
    data.media_type_id = 1;
    if (data.attachment) {
      if (data.attachment.type.includes("image")) {
        data.media_type = "photo";
        data.media_type_id = 2;
      } else if (data.attachment.type.includes("audio")) {
        data.media_type = "audio";
        data.media_type_id = 4;
      } else if (data.attachment.type.includes("video")) {
        data.media_type = "video";
        data.media_type_id = 3;
      }
    }
    return axios.post(`/user/team/poll`, data);
  }
  getPollDetailAfterResponse(teamId, pollId) {
    return axios.get(`/user/team/${teamId}/poll/${pollId}/metrics`);
  }
  getPollDetailBeforeResponse(teamId, pollId) {
    return axios.get(`/user/team/${teamId}/poll/${pollId}`);
  }
  updatePollResponse(data, teamId, pollId) {
    return axios.post(`/user/team/${teamId}/poll/${pollId}`, data);
  }
  deletePoll(teamId, pollId) {
    return axios.delete(`/user/team/${teamId}/poll/${pollId}`);
  }
}
export default new PollService();
